<div class="drivers-activity h-100" [ngClass]="{'drivers-activity--full-height': isExpanded}">
  <!-- Header Section -->
  <div class="drivers-activity__header d-flex justify-content-between align-items-center">
    <div class="drivers-activity__title">
      <span class="drivers-activity__title-icon">
        <i class="ph-duotone text-secondary" [ngClass]="icon"></i>
      </span>
      <span>{{ title }}<span class="drivers-activity__title-count">{{ count }}</span></span>
    </div>

    <!-- Close Button -->
    @if (isModal) {
      <button type="button" class="drivers-activity__close-btn btn btn-outline-secondary close"
        (click)="closeModal()" [attr.aria-label]="'common.close' | transloco">
        <span aria-hidden="true">&times;</span>
      </button>
    }

    @if (!isModal) {
      <a class="drivers-activity__title-expand" (click)="toggleExpand()">
        <i class="ph" [ngClass]="isExpanded ? 'ph-arrows-in' : 'ph-arrows-out'"></i>
      </a>
    }
  </div>

  <div class="drivers-activity__body">
    @if (isLoading) {
      <div class="drivers-activity__state">
        <span class="spinner-border"></span>
      </div>
    }

    @if (!isLoading && hasError) {
      <div class="drivers-activity__state">
        <app-error-state></app-error-state>
      </div>
    }

    @if (!isLoading && !hasError && !filteredDriversData.length) {
      <div class="drivers-activity__state">
        <app-empty-state></app-empty-state>
      </div>
    }

    @if (!isLoading && !hasError && filteredDriversData.length) {
      <div class="table-wrapper" infiniteScroll
        (scrolled)="onScroll()" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300" [scrollWindow]="false">
        <table class="table driver-profile">
          <thead>
            <tr>
              @for (header of columnHeaders; track header) {
                <th>{{ header }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (driver of !isExpanded ? filteredDriversData.slice(0, 5) : filteredDriversData; track driver) {
              <tr>
                <td>
                  <span class="fw-bold d-block driver-profile__name">{{
                    driver.firstName + ' ' + driver.lastName
                  }}</span>
                </td>
                <td class="driver-profile__vehicle">
                  <span class="truncate-text" [title]="driver.assetName" [ngClass]="{'driver-profile__vehicle_in-yard': !driver.assetName}">
                    {{ driver.assetName || '-' }}
                  </span>
                </td>
                <td>
                  <app-time-status-indicator [startTime]="driver.startTime" [showDuration]="true"
                    [durationSeconds]="driver.driverTimerSettingsTimeThreshold"
                    [statusTable]="true" />
                  </td>
                  @if (driver.totalDuration || this.columnHeaders.length > 3 && !isLocationColumn) {
                    <td>
                      <div class="driver-profile__log d-inline-flex align-items-center gap-2">
                        <span class="driver-profile__log-time">
                          {{ formatDuration(driver.totalDuration) }}
                        </span>
                      </div>
                    </td>
                  }
                  @if (isLocationColumn) {
                    <td>
                      <span class="truncate-text" [title]="driver.location" [ngClass]="{'driver-profile__vehicle_in-yard': !driver.location}">{{ driver.location || '-' }}</span>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
          @if (isPageLoading && !isLoading) {
            <div class="drivers-activity__page-loader">
              <span class="spinner-border"></span>
            </div>
          }
        </div>
      }
    </div>
  </div>